import { render, staticRenderFns } from "./receive_detail.vue?vue&type=template&id=0cf6b6b9&scoped=true"
import script from "./receive_detail.vue?vue&type=script&lang=js"
export * from "./receive_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf6b6b9",
  null
  
)

export default component.exports